export default __webpack_public_path__ + "static/media/tick-solo.d3024c3b.svg";